const setActivationModal = (payload) => ({
  type: "SET_ACTIVATION_MODAL",
  payload,
});

const removeActivationModal = (payload) => ({
  type: "REMOVE_ACTIVATION_MODAL",
  payload,
});

const clearActivationModal = () => ({
  type: "CLEAR_ACTIVATION_MODAL",
});

export default {
  setActivationModal,
  removeActivationModal,
  clearActivationModal,
};
